"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConstructionType = void 0;
var ConstructionType;
(function (ConstructionType) {
    ConstructionType["Frame"] = "Frame";
    ConstructionType["Masonry"] = "Joisted Masonry";
    ConstructionType["NonCombustible"] = "Non-Combustible";
    ConstructionType["MasonryNonCombustible"] = "Masonry NonCombustible";
    ConstructionType["Modified"] = "Modified Fire Resistive";
    ConstructionType["FireResistive"] = "Fire Resistive";
    ConstructionType["Aluminum"] = "Aluminum";
    ConstructionType["PlasticVinyl"] = "Plastic/Vinyl";
    ConstructionType["Unknown"] = "Unknown";
})(ConstructionType = exports.ConstructionType || (exports.ConstructionType = {}));
